import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import { ReviewForm } from './../forms'
import { Dashboard } from './../layouts'

const styles = theme => ({
    //
})

class ReviewNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            title: 'Reviews'
        }
    }

    render() {
        const { title } = this.state
        return (
            <Dashboard title={title}>
                <ReviewForm 
                    path="reviews"
                    method="post"
                    message="Амжилттай нэмэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(ReviewNew)
